import axios from "axios";

export const postFormDataApiCaller = async (endPoint, formData) => {
  const token = sessionStorage.getItem("token");
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  try {
    const url = baseUrl + endPoint;
    let headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    // Don't set Content-Type for multipart/form-data - let axios set it with proper boundary
    const response = await axios.post(url, formData, { headers });
    return response;
  } catch (error) {
    return error;
  }
};

export const putFormDataApiCaller = async (endPoint, formData) => {
  const token = sessionStorage.getItem("token");
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  try {
    const url = baseUrl + endPoint;
    let headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    // Don't set Content-Type for multipart/form-data - let axios set it with proper boundary
    const response = await axios.put(url, formData, { headers });
    return response;
  } catch (error) {
    return error;
  }
};

export const postApiCaller = async (endPoint, body) => {
  const token = sessionStorage.getItem("token");
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {};
  if (token) {
    header.Authorization = `Bearer ${token}`;
  }
  try {
    const url = baseUrl + endPoint;
    const response = await axios.post(url, body, { headers: header });
    return response;
  } catch (error) {
    return error;
  }
};

export const getApiCaller = async (endPoint) => {
  const token = sessionStorage.getItem("token");
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {};
  if (token) {
    header.Authorization = `Bearer ${token}`;
  }
  try {
    const url = baseUrl + endPoint;
    const response = await axios.get(url, { headers: header });
    return response;
  } catch (error) {
    return error;
  }
};

export const putApiCaller = async (endPoint, body) => {
  const token = sessionStorage.getItem("token");
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {};
  if (token) {
    header.Authorization = `Bearer ${token}`;
  }
  try {
    const url = baseUrl + endPoint;
    const response = await axios.put(url, body, { headers: header });
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteApiCaller = async (endPoint, body = null) => {
  const token = sessionStorage.getItem("token");
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {};
  if (token) {
    header.Authorization = `Bearer ${token}`;
  }
  try {
    const url = baseUrl + endPoint;
    const config = { headers: header };
    if (body) {
      config.data = body;
    }
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const patchApiCaller = async (endPoint, body) => {
  const token = sessionStorage.getItem("token");
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {};
  if (token) {
    header.Authorization = `Bearer ${token}`;
  }
  try {
    const url = baseUrl + endPoint;
    const response = await axios.patch(url, body, { headers: header });
    return response;
  } catch (error) {
    return error;
  }
};
